module.exports = __webpack_public_path__ + "static/media/archived.26417b03.svg";